import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((res) => setSettings(res.data)).catch(() => setSettings({}));
  }, []);

  return <SiteContext.Provider value={{ settings: settings || {} }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
